import { render, staticRenderFns } from "./kamitakuCheckpoint.vue?vue&type=template&id=1bf6468d&scoped=true&"
import script from "./kamitakuCheckpoint.vue?vue&type=script&lang=js&"
export * from "./kamitakuCheckpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6468d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf6468d')) {
      api.createRecord('1bf6468d', component.options)
    } else {
      api.reload('1bf6468d', component.options)
    }
    module.hot.accept("./kamitakuCheckpoint.vue?vue&type=template&id=1bf6468d&scoped=true&", function () {
      api.rerender('1bf6468d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/kamitaku/kamitakuCheckpoint.vue"
export default component.exports